import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Badge from "@mui/material/Badge";
import NotificationBadge from "../../style/NotificationBadge";

import {
    FiHome,
    FiUsers,
    // FiBook,
    FiCalendar,
    FiShoppingBag,
    FiMessageCircle,
} from "react-icons/fi";
import { useNetwork } from "../NetworkProvider";

import FastAPIClient from "../../client";
import config from "../../config";

const client = new FastAPIClient(config);

function Footer({ setIsMobileProfileOpen, setIsNotificationsModalOpen }) {
    const {
        newNotifications,
        getUserNotifications,
        isOnline,
        messagesNotifications,
        getMessagesNotifications,
    } = useNetwork();
    const location = useLocation();
    const navigate = useNavigate();
    const currentPage = location.pathname;
    const [isClientPage, setIsClientPage] = useState(false);
    const selectedPageStyle = "text-black";
    const selectedPageFontStyle = "text-xxs mt-2 font-bold text-black";

    const [user, setUser] = useState(false);

    // Function to fetch user data and save it in localStorage
    const fetchUserData = async () => {
        try {
            const data = await client.fetchUser();

            // Set user state
            await setUser(data);
            // Save user data in localStorage
            localStorage.setItem("user", JSON.stringify(data));
            localStorage.setItem("language", data.language);
        } catch (error) {
            console.error("Error fetching user data:", error);
        }
    };

    useEffect(() => {
        // Check if user is online
        if (user.user_id && navigator.onLine) {
            // Run immediately when the component mounts
            getMessagesNotifications(user.user_id);

            // Set an interval to call getNotifications every 30 seconds (30000 milliseconds)
            const interval = setInterval(() => {
                if (navigator.onLine) {
                    getMessagesNotifications(user.user_id);
                }
            }, 30000);

            // Cleanup the interval when the component unmounts or when the user_id or selectedClient changes
            return () => clearInterval(interval);
        }
    }, [user.user_id]);

    useEffect(() => {
        fetchUserData();
    }, []);

    // Check if the page path is the "client" page or if the client_id is in the query string
    useEffect(() => {
        const currentPage = location.pathname;
        const searchParams = new URLSearchParams(location.search);
        const clientId = searchParams.get("client_id");

        // If the path is "client" or if client_id exists in the query string, hide the footer
        if (
            currentPage.split("/")[1] === "client" ||
            clientId ||
            currentPage.split("/")[1] === "settings" ||
            currentPage.split("/")[1] === "lead"
        ) {
            setIsClientPage(true);
        } else {
            setIsClientPage(false);
        }
    }, [location]);

    // Function to handle navigation with clean URLs
    const handleNavigate = (path) => {
        if (isOnline) {
            getUserNotifications();
        }
        setIsMobileProfileOpen(false);
        setIsNotificationsModalOpen(false);
        // Remove settings and notifications from the URL
        const params = new URLSearchParams(location.search);
        params.delete("settings");
        params.delete("notifications");

        // Navigate to the clean path
        navigate(`${path}${params.toString() ? "?" + params.toString() : ""}`);
    };

    return (
        <footer
            style={{ flexShrink: 0, width: "100%", borderTopWidth: "0.5px" }}
            className={`text-center text-black z-40 sticky border-gray-200 pb-5 md:hidden pt-2 bg-white ${
                isClientPage && "hidden"
            }`}
        >
            <div className="flex flex-row w-full items-center pb-2 pt-2 text-xl">
                <div className="flex flex-col items-center w-1/4">
                    <Badge
                        variant="dot"
                        sx={{
                            "& .MuiBadge-badge": {
                                backgroundColor:
                                    newNotifications.length > 0
                                        ? currentPage !== "/home" &&
                                          currentPage !== "/"
                                            ? "#ff3838"
                                            : "transparent"
                                        : "transparent",
                            },
                        }}
                    >
                        <div
                            className="flex flex-col items-center cursor-pointer"
                            onClick={() => handleNavigate("/home")}
                        >
                            <div
                                className={
                                    currentPage === "/home" ||
                                    currentPage === "/"
                                        ? selectedPageStyle
                                        : "text-gray-500"
                                }
                            >
                                <FiHome />
                            </div>
                            <div
                                className={
                                    currentPage === "/home" ||
                                    currentPage === "/"
                                        ? selectedPageFontStyle
                                        : "text-xxs mt-2 font-semibold text-gray-500"
                                }
                            >
                                Accueil
                            </div>
                        </div>
                    </Badge>
                </div>
                <div className="flex flex-col items-center w-1/4">
                    <div
                        className="flex flex-col items-center cursor-pointer"
                        onClick={() => handleNavigate("/routing")}
                    >
                        <div
                            className={
                                currentPage === "/routing"
                                    ? selectedPageStyle
                                    : "text-gray-500"
                            }
                        >
                            <FiCalendar />
                        </div>
                        <div
                            className={
                                currentPage === "/routing"
                                    ? selectedPageFontStyle
                                    : "text-xxs mt-2 font-semibold text-gray-500"
                            }
                        >
                            Calendrier
                        </div>
                    </div>
                </div>
                {/* <div className="flex flex-col items-center w-1/5">
                    <Link to="/my-leads">
                        <FiFilter />
                    </Link>
                </div> */}
                <div className="flex flex-col items-center w-1/4">
                    <div
                        className="flex flex-col items-center cursor-pointer"
                        onClick={() => handleNavigate("/clients")}
                    >
                        <div
                            className={
                                currentPage === "/clients"
                                    ? selectedPageStyle
                                    : "text-gray-500"
                            }
                        >
                            <FiUsers />
                        </div>
                        <div
                            className={
                                currentPage === "/clients"
                                    ? selectedPageFontStyle
                                    : "text-xxs mt-2 font-semibold text-gray-500"
                            }
                        >
                            Clients
                        </div>
                    </div>
                </div>
                <div className="flex flex-col items-center w-1/4">
                    <div
                        className="flex flex-col items-center cursor-pointer"
                        onClick={() => handleNavigate("/products")}
                    >
                        <div
                            className={
                                currentPage === "/products"
                                    ? selectedPageStyle
                                    : "text-gray-500"
                            }
                        >
                            <FiShoppingBag />
                        </div>
                        <div
                            className={
                                currentPage === "/products"
                                    ? selectedPageFontStyle
                                    : "text-xxs mt-2 font-semibold text-gray-500"
                            }
                        >
                            Produits
                        </div>
                    </div>
                </div>
                <div className="flex flex-col items-center w-1/4">
                    <NotificationBadge
                        notifications={messagesNotifications}
                        currentPage={currentPage}
                        type="messages"
                    >
                        <div
                            className="flex flex-col items-center cursor-pointer"
                            onClick={() => handleNavigate("/chat")}
                        >
                            <div
                                className={
                                    currentPage === "/chat"
                                        ? selectedPageStyle
                                        : "text-gray-500"
                                }
                            >
                                <FiMessageCircle />
                            </div>
                            <div
                                className={
                                    currentPage === "/chat"
                                        ? selectedPageFontStyle
                                        : "text-xxs mt-2 font-semibold text-gray-500"
                                }
                            >
                                Chat
                            </div>
                        </div>
                    </NotificationBadge>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
